import React from 'react';
import { Platform, ScrollView, View } from 'react-native';
import { ButtonTypeDLS, ColorTokens, DividerSizeTokens, FontSizeTokens, StepperTypeTokens, TypographyTypeDLS, } from '@voltmoney/schema';
import CustomHeader from "../../customHeader/CustomHeader";
import { Typography } from "../../typography/Typography";
import { Divider } from "../../divider/Divider";
import { Button } from "../../button/Button";
import { addCommasToNumber } from "../utils";
import { Stepper } from "../../stepper/Stepper";
const PreDashboardScreen = ({ height, stepperData, goBackAction, needHelpAction, triggerAction, getPendingCreditRequestResponse, doneAction }) => {
    return (React.createElement(View, { style: { height: Platform.OS === "ios" ? height - 16 : height, marginHorizontal: -16 } },
        React.createElement(CustomHeader, { triggerAction: triggerAction, goBackAction: goBackAction, needHelpAction: needHelpAction }),
        React.createElement(ScrollView, { style: { marginHorizontal: 16, paddingTop: 24, paddingLeft: 16, paddingRight: 16, paddingBottom: 90, height: height - 44 } },
            React.createElement(View, { style: {
                    borderTopLeftRadius: 12,
                    borderTopRightRadius: 12,
                    borderWidth: 1,
                    borderColor: "#E4E7EC",
                    padding: 16
                } },
                React.createElement(Typography, { label: "Request for additional credit limit", typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Charcoal }),
                React.createElement(View, { style: { marginTop: 4 } },
                    React.createElement(Typography, { label: `₹${addCommasToNumber(getPendingCreditRequestResponse?.additionalCreditLimit)}`, fontSize: FontSizeTokens.XXXXL, lineHeight: 40, fontWeight: "700", color: ColorTokens.Secondary_100 })),
                React.createElement(View, { style: { marginTop: 16, backgroundColor: "#F9FAFB", borderRadius: 8, padding: 16 } },
                    React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between' } },
                        React.createElement(Typography, { label: "Existing credit limit", typeDLS: TypographyTypeDLS.B2R }),
                        React.createElement(Typography, { label: `₹${addCommasToNumber(getPendingCreditRequestResponse?.initialCreditLimit)}`, typeDLS: TypographyTypeDLS.B2M, color: ColorTokens.Secondary_100 })),
                    React.createElement(View, { style: {
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            marginTop: 12,
                            marginBottom: 12
                        } },
                        React.createElement(Typography, { label: "Additional credit limit", typeDLS: TypographyTypeDLS.B2R }),
                        React.createElement(Typography, { label: `₹${addCommasToNumber(getPendingCreditRequestResponse?.additionalCreditLimit)}`, typeDLS: TypographyTypeDLS.B2M, color: ColorTokens.Secondary_100 })),
                    React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk }),
                    React.createElement(View, { style: {
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            marginTop: 12,
                        } },
                        React.createElement(Typography, { label: "Updated credit limit", typeDLS: TypographyTypeDLS.B2S }),
                        React.createElement(Typography, { label: `₹${addCommasToNumber(getPendingCreditRequestResponse?.updatedCreditLimit)}`, typeDLS: TypographyTypeDLS.B2B, color: ColorTokens.Secondary_100 })))),
            React.createElement(View, { style: {
                    borderBottomLeftRadius: 12,
                    borderBottomRightRadius: 12,
                    borderWidth: 1,
                    borderColor: "#E4E7EC",
                    paddingTop: 24,
                    paddingHorizontal: 16,
                    paddingBottom: 16
                } },
                React.createElement(Stepper, { type: StepperTypeTokens.VERTICAL, data: stepperData, isProcessing: true }))),
        React.createElement(View, { style: { position: 'absolute', bottom: 0, width: '100%', backgroundColor: 'white' } },
            React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk, height: 1 }),
            React.createElement(View, { style: { padding: 16 } },
                React.createElement(Button, { typeDLS: ButtonTypeDLS.PRIMARY, label: "Done", fontSize: FontSizeTokens.SM, onPress: () => {
                        triggerAction({
                            ...doneAction
                        });
                    } })))));
};
export default PreDashboardScreen;
